/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteDocumentStatus;

(function (QuoteDocumentStatus) {
  QuoteDocumentStatus["PROCESSING"] = "processing";
  QuoteDocumentStatus["PROCESSED"] = "processed";
  QuoteDocumentStatus["FAILED"] = "failed";
})(QuoteDocumentStatus || (QuoteDocumentStatus = {}));